/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location, LocationPagination } from 'model/location';

export interface LocationState {
    status: LocationStatus;
    loading: boolean;
    error?: string;
    savedLocation?: Location;
    locations: Array<Location>;
    pagination: LocationPagination;
}

export enum LocationStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Saving,
    // eslint-disable-next-line no-unused-vars
    SaveSuccess
}
